import { init as initFMS } from '@storebrand-digital/fms-translations';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { authenticate } from 'Components/KeycloakWrapper';
import { RouteName } from 'Features/router';
import packageJson from '../package.json';
import { App } from './app';
import en from './fms-fallbacks/fallback-en.json';
import no from './fms-fallbacks/fallback-no.json';

if (process.env.NODE_ENV === 'development') {
  // Enforce basename (see ./src/router/index.tsx) in path
  if (!window.location.pathname.includes(RouteName.MY_INSURANCE_PAGES)) {
    window.location.replace(
      packageJson.publicPath + window.location.pathname.substring(1),
    );
  }
}

(async function bootstrap(): Promise<void> {
  await authenticate();

  await initFMS({
    clientId: packageJson.name,
    documentIds: ['myPagesInsuranceWeb'],
    fallback: { no, en },
    language: 'no',
    version: window.env.TRANSLATION_VERSION as 'pending' | 'active',
  });

  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App />);
  }
})();
